import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map} from 'rxjs/operators';
import { GetUserListBo } from './users.model';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs/Subject';
  
import { GlobalComponent } from 'src/app/global/global.component';
import { ErrorService } from 'src/app/error.service';
import { GeneralService } from 'src/app/service/general.service';

@Injectable()

export class GetHTTPService extends Subject<DataStateChangeEventArgs>{
  constructor(private http: HttpClient, public errorService: ErrorService, public global: GlobalComponent, public general:GeneralService) {
    super();
  }
  public execute(state: GetUserListBo): void {
    this.getCareList(state).subscribe(x => super.next(x));
  }
 
  getCareList(state?: GetUserListBo): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/User/GetUserList?", state)
      .pipe(map(
        (response: any) =>
          <any>{
            result: response['result'],
            count: response['count']
          }
      )).pipe(map((e:any)=>{
           
            e.result.forEach(element => {
              element.phone1 =element.phone1!=null? this.general.reconverPhoneGoogleLibhttpsave(element.phone1):null;
              element.phone2 =element.phone2!=null? this.general.reconverPhoneGoogleLibhttpsave(element.phone2):null;
            })
           
            return e;})


 ) }
}
